<template>
	<v-container class="ma-0 pa-0">
		<v-card flat>
			<v-card-text>
				<v-layout
					v-for="day in dayTypes"
					:key="day.value"
					row
					wrap
					align-center
					class="mb-3 border-bottom"
				>
					<v-flex xs12 md2>
						<span class="subheading font-weight-bold">{{ day.text }}</span>
					</v-flex>

					<v-flex xs12 md7>
						<v-layout
							row
							wrap
							v-for="(slot, index) in getSlotsForDay(day.value)"
							:key="index"
							class="mb-2"
							align-center
						>
							<v-flex xs5 px-1>
								<v-menu
									:close-on-content-click="false"
									lazy
									transition="scale-transition"
									offset-y
									full-width
									min-width="290px"
								>
									<v-text-field
										slot="activator"
										v-model="slot.openTime"
										label="Von"
										prepend-icon="access_time"
										readonly
										dense
										hide-details
									></v-text-field>
									<v-time-picker
										v-model="slot.openTime"
										format="24hr"
										@change="saveLocal"
									></v-time-picker>
								</v-menu>
							</v-flex>

							<v-flex xs5 px-1>
								<v-menu
									:close-on-content-click="false"
									lazy
									transition="scale-transition"
									offset-y
									full-width
									min-width="290px"
								>
									<v-text-field
										slot="activator"
										v-model="slot.closeTime"
										label="Bis"
										prepend-icon="access_time"
										readonly
										dense
										hide-details
									></v-text-field>
									<v-time-picker
										v-model="slot.closeTime"
										format="24hr"
										@change="saveLocal"
									></v-time-picker>
								</v-menu>
							</v-flex>

							<v-flex xs2>
								<v-btn icon small @click="removeSlot(slot)">
									<v-icon color="red">delete</v-icon>
								</v-btn>
							</v-flex>
						</v-layout>
					</v-flex>

					<v-flex xs12 md3>
						<v-layout row>
							<v-btn
								v-if="getSlotsForDay(day.value).length < 2"
								icon
								class="blexon-button"
								title="Öffnungszeiten-Slot hinzufügen"
								@click="addSlot(day.value)"
							>
								<v-icon>add</v-icon>
							</v-btn>
							<v-btn
								v-if="getSlotsForDay(day.value).length > 0"
								icon
								flat
								title="Tag kopieren"
								@click="copyDay(day.value)"
							>
								<v-icon>content_copy</v-icon>
							</v-btn>
							<v-btn
								v-if="copiedSlots.length > 0"
								icon
								flat
								title="Tag einfügen"
								@click="pasteDay(day.value)"
							>
								<v-icon>content_paste</v-icon>
							</v-btn>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn class="blexon-button" :loading="isSaving" @click="save">Speichern</v-btn>
			</v-card-actions>
		</v-card>
	</v-container>
</template>

<script>
import httpClient from "../store/httpClient";

export default {
	props: {
		fertigerId: Number | String,
		// Expecting array of { dayType: int, openTime: string, closeTime: string }
		openingHours: Array,
	},
	data() {
		return {
			isSaving: false,
			localSlots: [], // Local slots to preserve pre-change-slots
			copiedSlots: [], // Slots that are held in memory when copying
			dayTypes: [
				{ text: "Montag", value: 0 },
				{ text: "Dienstag", value: 1 },
				{ text: "Mittwoch", value: 2 },
				{ text: "Donnerstag", value: 3 },
				{ text: "Freitag", value: 4 },
				// Saturday and Sunday are not used at the moment.
				{ text: "Vor Feiertagen", value: 10 },
			],
		};
	},
	watch: {
		openingHours: {
			immediate: true,
			handler(val) {
				this.localSlots = val
					? val.map((s) => ({
							dayType: s.dayType,
							// TimeSpan comes as HH:mm:ss, v-time-picker wants HH:mm
							openTime: s.openTime ? s.openTime.substring(0, 5) : "08:00",
							closeTime: s.closeTime ? s.closeTime.substring(0, 5) : "17:00",
						}))
					: [];
			},
		},
	},
	methods: {
		getSlotsForDay(dayValue) {
			return this.localSlots.filter((s) => s.dayType === dayValue);
		},
		addSlot(dayValue) {
			console.log(dayValue);
			this.localSlots.push({
				dayType: dayValue,
				openTime: "08:00",
				closeTime: "12:00",
			});
		},
		removeSlot(slot) {
			const index = this.localSlots.indexOf(slot);
			this.localSlots.splice(index, 1);
		},
		copyDay(dayValue) {
			const slotsToCopy = this.getSlotsForDay(dayValue);
			// Day type doesn't need to be saved.
			this.copiedSlots = slotsToCopy.map((s) => ({
				openTime: s.openTime,
				closeTime: s.closeTime,
			}));
		},
		pasteDay(targetDayValue) {
			if (!this.copiedSlots) return;

			this.localSlots = this.localSlots.filter((s) => s.dayType !== targetDayValue);
			this.copiedSlots.forEach((item) => {
				this.localSlots.push({
					dayType: targetDayValue,
					openTime: item.openTime,
					closeTime: item.closeTime,
				});
			});
		},
		saveLocal() {
			// Nothing to do right now.
		},
		async save() {
			this.isSaving = true;
			try {
				// Send localSlots back to API
				// Note: C# will accept "HH:mm" strings and convert them back to TimeSpans automatically
				await httpClient().post(
					`api/Fertiger/SaveOpeningHours?fertigerId=${this.fertigerId}`,
					this.localSlots
				);
				this.$emit("saved");
			} catch (err) {
				console.error("Opening hours couldn't be saved", err);
				this.$emit("failedToSave");
			} finally {
				this.isSaving = false;
			}
		},
	},
};
</script>

<style scoped>
.border-bottom {
	border-bottom: 1px solid #eee;
	padding-bottom: 10px;
}
</style>
